<script lang="ts" setup>
import { ref, watch } from "vue";
import { getBuildingEnergyLabels, getBuildingEnergyLabelsParty } from "@/services/api/chart.api";
import ChartBuildingEnergyLabels from "@/components/app/charts/ChartBuildingEnergyLabels.vue";
import { useToast } from "vue-toastification";
import LoaderSpinner from "@/components/general/LoaderSpinner.vue";

const toaster = useToast();

const props = defineProps({
  token: String,
  partyReference: String,
  filterData: { type: Array, default: () => [] },
  partyType: String,
  labelSource: String,
});

const energyLabels = ref<Record<string, number>>({});
const isLoading = ref(true);

watch(
  () => props.token,
  () => {
    if (props.token) {
      fetchTokenData();
    } else {
      energyLabels.value = {};
    }
  }
);

watch(
  () => [props.partyReference, props.filterData],
  () => {
    if (props.partyReference) {
      fetchBuildingEnergyLabelStatusData();
    } else {
      //this.tableData = {};
    }
  },
  { immediate: true }
);

async function fetchTokenData() {
  isLoading.value = true;
  const response = await getBuildingEnergyLabels(props.token, props.partyType, props.labelSource) as Record<string, number>;
  if (response) {
    energyLabels.value = response;
  }
  isLoading.value = false;
}

async function fetchBuildingEnergyLabelStatusData() {
  isLoading.value = true;

  const response = await getBuildingEnergyLabelsParty(props.partyReference, props.filterData, props.partyType, props.labelSource) as Record<string, number>;
  isLoading.value = false;

  if (response) {
    energyLabels.value = response;
  } else {
    toaster.error("Ophalen van de building EnergyLabels data is mislukt!");
  }
}
</script>

<template>
  <div class="widget-item">
    <slot name="headerwidget"></slot>
    <LoaderSpinner v-if="isLoading" :is-loading="isLoading" :min-height="170"></LoaderSpinner>
    <div v-else class="widget-wrapper widget-chart">
      <ChartBuildingEnergyLabels :party-type="props.partyType ?? ''" :radius="150" :sourceData="energyLabels"> </ChartBuildingEnergyLabels>
    </div>
  </div>
</template>
